module.exports = {
  "BREAKPOINT_XS": 0,
  "BREAKPOINT_S": 375,
  "BREAKPOINT_M": 768,
  "BREAKPOINT_L": 1024,
  "BREAKPOINT_XL": 1440,
  "BREAKPOINT_XXL": 1920,
  "COLOR_BASE_BRAND_WHITE": "#FFFFFF",
  "COLOR_BASE_BRAND_BLACK": "#000000",
  "COLOR_BASE_BRAND_PROGRESSIVE_RED": "#F50537",
  "COLOR_BASE_GREY_0": "#FFFFFF",
  "COLOR_BASE_GREY_5": "#F2F2F2",
  "COLOR_BASE_GREY_10": "#E5E5E5",
  "COLOR_BASE_GREY_15": "#D9D9D9",
  "COLOR_BASE_GREY_20": "#CCCCCC",
  "COLOR_BASE_GREY_30": "#B3B3B3",
  "COLOR_BASE_GREY_40": "#999999",
  "COLOR_BASE_GREY_50": "#808080",
  "COLOR_BASE_GREY_60": "#666666",
  "COLOR_BASE_GREY_70": "#4C4C4C",
  "COLOR_BASE_GREY_80": "#333333",
  "COLOR_BASE_GREY_90": "#1A1A1A",
  "COLOR_BASE_GREY_100": "#000000",
  "COLOR_BASE_SIGNAL_RED": "#EB0D3F",
  "COLOR_BASE_SIGNAL_GREEN": "#009900",
  "COLOR_BASE_SIGNAL_YELLOW": "#FFAA00",
  "COLOR_BASE_CHARGING_NEON_BLUE": "#2526FE",
  "COLOR_BASE_CHARGING_NEON_GREEN": "#15DA15",
  "COLOR_FORM_PRIMARY_LIGHT": "#333333",
  "COLOR_FORM_PRIMARY_DARK": "#D9D9D9",
  "COLOR_FORM_SECONDARY_LIGHT": "#666666",
  "COLOR_FORM_SECONDARY_DARK": "#CCCCCC",
  "COLOR_FORM_TERTIARY_LIGHT": "#808080",
  "COLOR_FORM_TERTIARY_DARK": "#B3B3B3",
  "COLOR_FORM_MUTED_PRIMARY_LIGHT": "#999999",
  "COLOR_FORM_MUTED_PRIMARY_DARK": "#999999",
  "COLOR_FORM_MUTED_SECONDARY_LIGHT": "#B3B3B3",
  "COLOR_FORM_MUTED_SECONDARY_DARK": "#808080",
  "COLOR_FORM_MUTED_TERTIARY_LIGHT": "#E5E5E5",
  "COLOR_FORM_MUTED_TERTIARY_DARK": "#333333",
  "COLOR_FORM_STRONG_LIGHT": "#000000",
  "COLOR_FORM_STRONG_DARK": "#FFFFFF",
  "COLOR_FORM_ERROR_LIGHT": "#EB0D3F",
  "COLOR_FORM_ERROR_DARK": "#EB0D3F",
  "COLOR_NOTIFICATION_NEUTRAL_LIGHT": "#666666",
  "COLOR_NOTIFICATION_NEUTRAL_DARK": "#CCCCCC",
  "COLOR_NOTIFICATION_ERROR_LIGHT": "#EB0D3F",
  "COLOR_NOTIFICATION_ERROR_DARK": "#EB0D3F",
  "COLOR_NOTIFICATION_WARNING_LIGHT": "#FFAA00",
  "COLOR_NOTIFICATION_WARNING_DARK": "#FFAA00",
  "COLOR_NOTIFICATION_SUCCESS_LIGHT": "#009900",
  "COLOR_NOTIFICATION_SUCCESS_DARK": "#009900",
  "COLOR_OPTION_PRIMARY_LIGHT": "#009900",
  "COLOR_OPTION_PRIMARY_DARK": "#009900",
  "COLOR_OPTION_SECONDARY_LIGHT": "#D9D9D9",
  "COLOR_OPTION_SECONDARY_DARK": "#4C4C4C",
  "COLOR_OPTION_TERTIARY_LIGHT": "#FFFFFF",
  "COLOR_OPTION_TERTIARY_DARK": "#FFFFFF",
  "COLOR_OPTION_DISABLED_PRIMARY_LIGHT": "#D9F0D9",
  "COLOR_OPTION_DISABLED_PRIMARY_DARK": "#2A482A",
  "COLOR_OPTION_DISABLED_SECONDARY_LIGHT": "#E5E5E5",
  "COLOR_OPTION_DISABLED_SECONDARY_DARK": "#333333",
  "COLOR_OPTION_DISABLED_TERTIARY_LIGHT": "#FFFFFF",
  "COLOR_OPTION_DISABLED_TERTIARY_DARK": "#666666",
  "COLOR_TEXT_PRIMARY_LIGHT": "#000000",
  "COLOR_TEXT_PRIMARY_DARK": "#FFFFFF",
  "COLOR_TEXT_SECONDARY_LIGHT": "#333333",
  "COLOR_TEXT_SECONDARY_DARK": "#F2F2F2",
  "COLOR_TEXT_INACTIVE_LIGHT": "#666666",
  "COLOR_TEXT_INACTIVE_DARK": "#CCCCCC",
  "COLOR_TEXT_ERROR_LIGHT": "#EB0D3F",
  "COLOR_TEXT_ERROR_DARK": "#EB0D3F",
  "COLOR_UI_PRIMARY_LIGHT": "#000000",
  "COLOR_UI_PRIMARY_DARK": "#FFFFFF",
  "COLOR_UI_PRIMARY_INVERSE_LIGHT": "#FFFFFF",
  "COLOR_UI_PRIMARY_INVERSE_DARK": "#000000",
  "COLOR_UI_HOVER_LIGHT": "#4C4C4C",
  "COLOR_UI_HOVER_DARK": "#D9D9D9",
  "COLOR_UI_DISABLED_LIGHT": "#B3B3B3",
  "COLOR_UI_DISABLED_DARK": "#1A1A1A",
  "COLOR_UI_ERROR_LIGHT": "#EB0D3F",
  "COLOR_UI_ERROR_DARK": "#EB0D3F",
  "COLOR_UI_SUCCESS_LIGHT": "#009900",
  "COLOR_UI_SUCCESS_DARK": "#15DA15",
  "COLOR_UI_LABEL_HOVER_LIGHT": "#000000",
  "COLOR_UI_LABEL_HOVER_DARK": "#FFFFFF",
  "COLOR_UI_DIVIDER_PRIMARY_LIGHT": "#CCCCCC",
  "COLOR_UI_DIVIDER_PRIMARY_DARK": "#333333",
  "COLOR_UTILITY_BLACK_LIGHT": "#000000",
  "COLOR_UTILITY_BLACK_DARK": "#000000",
  "COLOR_UTILITY_WHITE_LIGHT": "#FFFFFF",
  "COLOR_UTILITY_WHITE_DARK": "#FFFFFF",
  "COLOR_UTILITY_NEUTRAL_0_LIGHT": "#FFFFFF",
  "COLOR_UTILITY_NEUTRAL_0_DARK": "#000000",
  "COLOR_UTILITY_NEUTRAL_5_LIGHT": "#F2F2F2",
  "COLOR_UTILITY_NEUTRAL_5_DARK": "#1A1A1A",
  "COLOR_UTILITY_NEUTRAL_10_LIGHT": "#E5E5E5",
  "COLOR_UTILITY_NEUTRAL_10_DARK": "#333333",
  "COLOR_UTILITY_NEUTRAL_15_LIGHT": "#D9D9D9",
  "COLOR_UTILITY_NEUTRAL_15_DARK": "#4C4C4C",
  "COLOR_UTILITY_NEUTRAL_20_LIGHT": "#CCCCCC",
  "COLOR_UTILITY_NEUTRAL_20_DARK": "#666666",
  "COLOR_UTILITY_NEUTRAL_30_LIGHT": "#B3B3B3",
  "COLOR_UTILITY_NEUTRAL_30_DARK": "#808080",
  "COLOR_UTILITY_NEUTRAL_40_LIGHT": "#999999",
  "COLOR_UTILITY_NEUTRAL_40_DARK": "#999999",
  "COLOR_UTILITY_NEUTRAL_50_LIGHT": "#808080",
  "COLOR_UTILITY_NEUTRAL_50_DARK": "#B3B3B3",
  "COLOR_UTILITY_NEUTRAL_60_LIGHT": "#666666",
  "COLOR_UTILITY_NEUTRAL_60_DARK": "#CCCCCC",
  "COLOR_UTILITY_NEUTRAL_70_LIGHT": "#4C4C4C",
  "COLOR_UTILITY_NEUTRAL_70_DARK": "#D9D9D9",
  "COLOR_UTILITY_NEUTRAL_80_LIGHT": "#333333",
  "COLOR_UTILITY_NEUTRAL_80_DARK": "#E5E5E5",
  "COLOR_UTILITY_NEUTRAL_90_LIGHT": "#1A1A1A",
  "COLOR_UTILITY_NEUTRAL_90_DARK": "#F2F2F2",
  "COLOR_UTILITY_NEUTRAL_100_LIGHT": "#000000",
  "COLOR_UTILITY_NEUTRAL_100_DARK": "#FFFFFF",
  "PAGE_MARGIN_XS": 16,
  "PAGE_MARGIN_S": 28,
  "PAGE_MARGIN_M": 40,
  "PAGE_MARGIN_L": 60,
  "PAGE_MARGIN_XL": 96,
  "PAGE_MARGIN_XXL": 96,
  "MAX_CONTENT_WIDTH": 1920,
  "SPACING_XXS_XS": 4,
  "SPACING_XXS_S": 4,
  "SPACING_XXS_M": 4,
  "SPACING_XXS_L": 4,
  "SPACING_XXS_XL": 4,
  "SPACING_XXS_XXL": 4,
  "SPACING_XS_XS": 8,
  "SPACING_XS_S": 8,
  "SPACING_XS_M": 8,
  "SPACING_XS_L": 8,
  "SPACING_XS_XL": 8,
  "SPACING_XS_XXL": 8,
  "SPACING_S_XS": 12,
  "SPACING_S_S": 12,
  "SPACING_S_M": 12,
  "SPACING_S_L": 12,
  "SPACING_S_XL": 12,
  "SPACING_S_XXL": 12,
  "SPACING_M_XS": 16,
  "SPACING_M_S": 16,
  "SPACING_M_M": 16,
  "SPACING_M_L": 16,
  "SPACING_M_XL": 16,
  "SPACING_M_XXL": 16,
  "SPACING_L_XS": 24,
  "SPACING_L_S": 24,
  "SPACING_L_M": 24,
  "SPACING_L_L": 24,
  "SPACING_L_XL": 24,
  "SPACING_L_XXL": 24,
  "SPACING_XL_XS": 28,
  "SPACING_XL_S": 28,
  "SPACING_XL_M": 28,
  "SPACING_XL_L": 28,
  "SPACING_XL_XL": 32,
  "SPACING_XL_XXL": 44,
  "SPACING_XXL_XS": 36,
  "SPACING_XXL_S": 36,
  "SPACING_XXL_M": 36,
  "SPACING_XXL_L": 40,
  "SPACING_XXL_XL": 52,
  "SPACING_XXL_XXL": 68,
  "SPACING_XXXL_XS": 40,
  "SPACING_XXXL_S": 40,
  "SPACING_XXXL_M": 48,
  "SPACING_XXXL_L": 60,
  "SPACING_XXXL_XL": 80,
  "SPACING_XXXL_XXL": 100,
  "TYPOGRAPHY_COPY_1_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_COPY_1_FONT_SIZE": 16,
  "TYPOGRAPHY_COPY_1_LINE_HEIGHT": 24,
  "TYPOGRAPHY_COPY_1_FONT_STRETCH": 105,
  "TYPOGRAPHY_COPY_2_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_COPY_2_FONT_SIZE": 12,
  "TYPOGRAPHY_COPY_2_LINE_HEIGHT": 20,
  "TYPOGRAPHY_COPY_2_FONT_STRETCH": 105,
  "TYPOGRAPHY_COPY_3_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_COPY_3_FONT_SIZE": 10,
  "TYPOGRAPHY_COPY_3_LINE_HEIGHT": 16,
  "TYPOGRAPHY_COPY_3_FONT_STRETCH": 105,
  "TYPOGRAPHY_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_FONT_WEIGHTS_NORMAL": 400,
  "TYPOGRAPHY_FONT_WEIGHTS_BOLD": 700,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_SIZE": 40,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XS_LINE_HEIGHT": 56,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_SIZE": 40,
  "TYPOGRAPHY_HEADING_DISPLAY_1_S_LINE_HEIGHT": 56,
  "TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_SIZE": 48,
  "TYPOGRAPHY_HEADING_DISPLAY_1_M_LINE_HEIGHT": 68,
  "TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_SIZE": 60,
  "TYPOGRAPHY_HEADING_DISPLAY_1_L_LINE_HEIGHT": 84,
  "TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_SIZE": 72,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XL_LINE_HEIGHT": 100,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_SIZE": 84,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XXL_LINE_HEIGHT": 116,
  "TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_SIZE": 36,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XS_LINE_HEIGHT": 52,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_SIZE": 36,
  "TYPOGRAPHY_HEADING_DISPLAY_2_S_LINE_HEIGHT": 52,
  "TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_SIZE": 36,
  "TYPOGRAPHY_HEADING_DISPLAY_2_M_LINE_HEIGHT": 52,
  "TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_SIZE": 44,
  "TYPOGRAPHY_HEADING_DISPLAY_2_L_LINE_HEIGHT": 64,
  "TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_SIZE": 52,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XL_LINE_HEIGHT": 76,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_SIZE": 60,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XXL_LINE_HEIGHT": 84,
  "TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_SIZE": 28,
  "TYPOGRAPHY_HEADING_ORDER_1_XS_LINE_HEIGHT": 44,
  "TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_1_S_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_1_S_FONT_SIZE": 28,
  "TYPOGRAPHY_HEADING_ORDER_1_S_LINE_HEIGHT": 44,
  "TYPOGRAPHY_HEADING_ORDER_1_S_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_1_M_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_1_M_FONT_SIZE": 28,
  "TYPOGRAPHY_HEADING_ORDER_1_M_LINE_HEIGHT": 44,
  "TYPOGRAPHY_HEADING_ORDER_1_M_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_1_L_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_1_L_FONT_SIZE": 36,
  "TYPOGRAPHY_HEADING_ORDER_1_L_LINE_HEIGHT": 52,
  "TYPOGRAPHY_HEADING_ORDER_1_L_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_SIZE": 40,
  "TYPOGRAPHY_HEADING_ORDER_1_XL_LINE_HEIGHT": 60,
  "TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_SIZE": 44,
  "TYPOGRAPHY_HEADING_ORDER_1_XXL_LINE_HEIGHT": 68,
  "TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_SIZE": 24,
  "TYPOGRAPHY_HEADING_ORDER_2_XS_LINE_HEIGHT": 36,
  "TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_2_S_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_2_S_FONT_SIZE": 24,
  "TYPOGRAPHY_HEADING_ORDER_2_S_LINE_HEIGHT": 36,
  "TYPOGRAPHY_HEADING_ORDER_2_S_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_2_M_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_2_M_FONT_SIZE": 24,
  "TYPOGRAPHY_HEADING_ORDER_2_M_LINE_HEIGHT": 36,
  "TYPOGRAPHY_HEADING_ORDER_2_M_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_2_L_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_2_L_FONT_SIZE": 28,
  "TYPOGRAPHY_HEADING_ORDER_2_L_LINE_HEIGHT": 44,
  "TYPOGRAPHY_HEADING_ORDER_2_L_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_SIZE": 32,
  "TYPOGRAPHY_HEADING_ORDER_2_XL_LINE_HEIGHT": 48,
  "TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_SIZE": 36,
  "TYPOGRAPHY_HEADING_ORDER_2_XXL_LINE_HEIGHT": 52,
  "TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_SIZE": 20,
  "TYPOGRAPHY_HEADING_ORDER_3_XS_LINE_HEIGHT": 32,
  "TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_3_S_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_3_S_FONT_SIZE": 20,
  "TYPOGRAPHY_HEADING_ORDER_3_S_LINE_HEIGHT": 32,
  "TYPOGRAPHY_HEADING_ORDER_3_S_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_3_M_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_3_M_FONT_SIZE": 20,
  "TYPOGRAPHY_HEADING_ORDER_3_M_LINE_HEIGHT": 32,
  "TYPOGRAPHY_HEADING_ORDER_3_M_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_3_L_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_3_L_FONT_SIZE": 20,
  "TYPOGRAPHY_HEADING_ORDER_3_L_LINE_HEIGHT": 32,
  "TYPOGRAPHY_HEADING_ORDER_3_L_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_SIZE": 24,
  "TYPOGRAPHY_HEADING_ORDER_3_XL_LINE_HEIGHT": 36,
  "TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_SIZE": 24,
  "TYPOGRAPHY_HEADING_ORDER_3_XXL_LINE_HEIGHT": 36,
  "TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_SIZE": 16,
  "TYPOGRAPHY_HEADING_ORDER_4_XS_LINE_HEIGHT": 24,
  "TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_4_S_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_4_S_FONT_SIZE": 16,
  "TYPOGRAPHY_HEADING_ORDER_4_S_LINE_HEIGHT": 24,
  "TYPOGRAPHY_HEADING_ORDER_4_S_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_4_M_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_4_M_FONT_SIZE": 16,
  "TYPOGRAPHY_HEADING_ORDER_4_M_LINE_HEIGHT": 24,
  "TYPOGRAPHY_HEADING_ORDER_4_M_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_4_L_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_4_L_FONT_SIZE": 16,
  "TYPOGRAPHY_HEADING_ORDER_4_L_LINE_HEIGHT": 24,
  "TYPOGRAPHY_HEADING_ORDER_4_L_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_SIZE": 18,
  "TYPOGRAPHY_HEADING_ORDER_4_XL_LINE_HEIGHT": 28,
  "TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_STRETCH": 130,
  "TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_FAMILY": "AudiType, sans-serif",
  "TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_SIZE": 20,
  "TYPOGRAPHY_HEADING_ORDER_4_XXL_LINE_HEIGHT": 32,
  "TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_STRETCH": 130,
}